/**
 * Song List Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Song List guide.
 */
export const songListTourConfig = {
  id: 'song-list-onboarding',
  storageKey: 'triad_tour_song_list_completed',
  steps: [
    {
      id: 'song-add-btn',
      target: '[data-tour="song-add-btn"], [data-tour="crud-add-btn"]',
      titleKey: 'tour.songList.addTitle',
      descriptionKey: 'tour.songList.addDesc',
      position: 'bottom',
      align: 'end'
    },
    {
      id: 'song-search-input',
      target: '[data-tour="song-search-input"], [data-tour="crud-search-input"]',
      titleKey: 'tour.songList.searchTitle',
      descriptionKey: 'tour.songList.searchDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'song-table',
      target: '[data-tour="song-table"], [data-tour="crud-table"]',
      titleKey: 'tour.songList.tableTitle',
      descriptionKey: 'tour.songList.tableDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default songListTourConfig;
